import React from "react";
import Header from "../header/Header";
import "../holidayList/HolidayList.css";
import Axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import {
  LuCalendarHeart,
  LuCheck,
  LuCheckCircle2,
  LuLoader2,
  LuPalmtree,
  LuPartyPopper,
} from "react-icons/lu";
import { verifyToken } from "../../helpers/signJwtToken";
import { UiButton, TEXTAREA } from "../ui/ui";
import { ModalShell } from "../dashboard/WeeklyPriorities";
const config = require("../../config/config");
const queryString = require("query-string");

const OPTIONAL_TYPE = 2;

const isWeekend = (date) => [0, 6].includes(moment(date).day());

const FILTERS = [
  { key: "all", label: "All" },
  { key: "public", label: "Public" },
  { key: "optional", label: "Optional" },
];

class HolidayList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      holidays: [],
      appliedDates: [],
      leaveBalance: { plBalance: 0, chBalance: 0 },
      filter: "all",
      loading: true,
      showModal: false,
      details: {},
      userDetails: null,
    };

    this.getHolidayList = this.getHolidayList.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.refreshLeaves = this.refreshLeaves.bind(this);
  }

  async getUserDetails() {
    let userDetails = localStorage.getItem("token");
    if (userDetails) {
      const verifiedToken = await verifyToken(userDetails);
      return verifiedToken?.payload?.sub;
    }
    return null;
  }

  async componentDidMount() {
    const userDetails = await this.getUserDetails();
    this.setState(() => ({
      userDetails: { ...userDetails },
    }));
    this.getHolidayList();
    this.refreshLeaves(userDetails);
  }

  toggleModal(toggle, holidayName, holidayDate) {
    this.setState({
      showModal: toggle,
      details: toggle ? { name: holidayName, date: holidayDate } : {},
    });
  }

  yearRange() {
    const year = moment().format("YYYY");
    return `${year}-01-01|${year}-12-31`;
  }

  getHolidayList() {
    let that = this;
    Axios.get(
      config.API_BASE +
        "/calender/getHolidayList?" +
        queryString.stringify({ dateBetween: this.yearRange() }),
    )
      .then(function (response) {
        let res = response.data;
        if (res.status && Array.isArray(res.data)) {
          const holidays = [...res.data].sort(
            (a, b) => moment(a.date).valueOf() - moment(b.date).valueOf(),
          );
          that.setState({ holidays });
        }
      })
      .catch(function (error) {
        console.log("error", error);
      })
      .finally(function () {
        that.setState({ loading: false });
      });
  }

  // Balance + which optional holidays have already been taken this year
  refreshLeaves(userDetails) {
    const user = userDetails || this.state.userDetails;
    if (!user?.id) return;
    let that = this;
    Axios.get(
      config.API_BASE +
        "/leave/getUserLeaves?" +
        queryString.stringify({ userId: user.id }),
    )
      .then(function (response) {
        const res = response.data;
        if (res.status && Array.isArray(res.data) && res.data[0]) {
          that.setState({ leaveBalance: res.data[0] });
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
    Axios.get(
      config.API_BASE +
        "/leave/getUserLeaveHistory?" +
        queryString.stringify({ userId: user.id, dateBetween: this.yearRange() }),
    )
      .then(function (response) {
        const res = response.data;
        if (res.status && Array.isArray(res.data)) {
          const appliedDates = res.data
            .filter(
              (row) =>
                Number(row.leaveType) === 2 &&
                String(row.transactionType) === "1" &&
                String(row.isCancelled) !== "1" &&
                row.isCancelled !== true,
            )
            .map((row) => moment(row.startDate).format("YYYY-MM-DD"));
          that.setState({ appliedDates });
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  }

  render() {
    const { holidays, filter, loading, appliedDates, leaveBalance } = this.state;
    const today = moment().startOf("day");
    const year = moment().format("YYYY");

    const publicCount = holidays.filter((h) => Number(h.type) !== OPTIONAL_TYPE).length;
    const optionalCount = holidays.length - publicCount;
    const nextHoliday = holidays.find((h) =>
      moment(h.date).isSameOrAfter(today, "day"),
    );

    const visible = holidays.filter((h) =>
      filter === "all"
        ? true
        : filter === "optional"
          ? Number(h.type) === OPTIONAL_TYPE
          : Number(h.type) !== OPTIONAL_TYPE,
    );
    const byMonth = [];
    visible.forEach((h) => {
      const month = moment(h.date).format(config.MOMENT_FULL_MONTH);
      let group = byMonth.find((g) => g.month === month);
      if (!group) {
        group = { month, items: [] };
        byMonth.push(group);
      }
      group.items.push(h);
    });

    return (
      <>
        <Header />
        <div className="container-fluid">
          <div className="tw-mx-auto tw-max-w-7xl tw-py-4 tw-font-sans tw-text-foreground sm:tw-py-6">
            <div className="tw-mb-6">
              <h1 className="tw-m-0 tw-text-2xl tw-font-semibold tw-leading-8 tw-text-foreground">
                Holidays {year}
              </h1>
              <div className="tw-mt-1 tw-text-sm tw-text-muted-foreground">
                Public holidays are off for everyone. Optional holidays can be
                taken using your optional leave.
              </div>
            </div>

            {/* Highlights */}
            <div className="tw-mb-6 tw-grid tw-gap-4 md:tw-grid-cols-3">
              <div className="tw-relative tw-overflow-hidden tw-rounded-lg tw-bg-gradient-primary tw-p-5 tw-text-white tw-shadow-medium md:tw-col-span-1">
                <LuPartyPopper
                  className="tw-absolute -tw-right-3 -tw-top-3 tw-text-[96px] tw-opacity-15"
                  aria-hidden="true"
                />
                <div className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-white/80">
                  Next holiday
                </div>
                {nextHoliday ? (
                  <>
                    <div className="tw-mt-1 tw-text-xl tw-font-semibold tw-leading-7">
                      {nextHoliday.holidayName}
                    </div>
                    <div className="tw-mt-0.5 tw-text-sm tw-text-white/90">
                      {moment(nextHoliday.date).format("dddd, DD MMMM")}
                    </div>
                    <div className="tw-mt-3 tw-inline-flex tw-items-center tw-rounded-full tw-bg-white/20 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold">
                      {countdown(nextHoliday.date)}
                      {Number(nextHoliday.type) === OPTIONAL_TYPE && " · Optional"}
                    </div>
                  </>
                ) : (
                  <div className="tw-mt-1 tw-text-base tw-font-semibold">
                    No more holidays this year
                  </div>
                )}
              </div>
              <StatCard
                icon={LuCalendarHeart}
                tone="tw-bg-primary/10 tw-text-primary"
                label="Holidays this year"
                value={holidays.length}
                detail={`${publicCount} public · ${optionalCount} optional`}
              />
              <StatCard
                icon={LuPalmtree}
                tone="tw-bg-amber-100 tw-text-amber-700"
                label="Optional leave left"
                value={leaveBalance.chBalance}
                detail="Use it on any optional holiday below"
              />
            </div>

            {/* Filter */}
            <div className="tw-mb-4 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3">
              <div
                className="tw-inline-flex tw-gap-1 tw-rounded-lg tw-bg-white tw-p-1 tw-shadow-soft"
                role="tablist"
                aria-label="Filter holidays"
              >
                {FILTERS.map((f) => (
                  <button
                    key={f.key}
                    type="button"
                    role="tab"
                    aria-selected={filter === f.key}
                    onClick={() => this.setState({ filter: f.key })}
                    className={`tw-h-8 tw-rounded-md tw-border-0 tw-px-3 tw-text-sm tw-font-medium tw-transition-colors ${
                      filter === f.key
                        ? "tw-bg-primary/10 tw-text-primary"
                        : "tw-bg-transparent tw-text-muted-foreground hover:tw-text-foreground"
                    }`}
                  >
                    {f.label}
                  </button>
                ))}
              </div>
              <div className="tw-flex tw-items-center tw-gap-4 tw-text-xs tw-text-muted-foreground">
                <span className="tw-inline-flex tw-items-center tw-gap-1.5">
                  <span className="tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-primary" />
                  Public
                </span>
                <span className="tw-inline-flex tw-items-center tw-gap-1.5">
                  <span className="tw-h-2.5 tw-w-2.5 tw-rounded-full tw-bg-amber-400" />
                  Optional
                </span>
              </div>
            </div>

            {loading ? (
              <div className="tw-grid tw-gap-4 sm:tw-grid-cols-2 xl:tw-grid-cols-3">
                {[0, 1, 2, 3, 4, 5].map((i) => (
                  <div
                    key={i}
                    className="tw-h-40 tw-animate-pulse tw-rounded-lg tw-bg-white/70"
                  />
                ))}
              </div>
            ) : byMonth.length === 0 ? (
              <div className="tw-rounded-lg tw-border tw-border-dashed tw-border-border tw-bg-white tw-px-4 tw-py-12 tw-text-center tw-text-sm tw-text-muted-foreground">
                No holidays to show.
              </div>
            ) : (
              <div className="tw-grid tw-items-start tw-gap-4 sm:tw-grid-cols-2 xl:tw-grid-cols-3">
                {byMonth.map((group) => {
                  return (
                    <section
                      key={group.month}
                      className="tw-rounded-lg tw-border tw-border-solid tw-border-border/60 tw-bg-card tw-shadow-soft"
                    >
                      <div className="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-b tw-border-solid tw-border-border tw-px-4 tw-py-3">
                        <h2 className="tw-m-0 tw-text-base tw-font-semibold tw-text-foreground">
                          {group.month}
                        </h2>
                        <span className="tw-text-xs tw-text-muted-foreground">
                          {group.items.length}{" "}
                          {group.items.length === 1 ? "holiday" : "holidays"}
                        </span>
                      </div>
                      <ul className="tw-m-0 tw-list-none tw-divide-y tw-divide-border tw-p-0">
                        {group.items.map((h) => (
                          <HolidayRow
                            key={`${h.date}-${h.holidayName}`}
                            holiday={h}
                            today={today}
                            applied={appliedDates.includes(
                              moment(h.date).format("YYYY-MM-DD"),
                            )}
                            onApply={() =>
                              this.toggleModal(true, h.holidayName, h.date)
                            }
                          />
                        ))}
                      </ul>
                    </section>
                  );
                })}
              </div>
            )}
          </div>
        </div>
        <ApplyLeaveModal
          showModal={this.state.showModal}
          userDetails={this.state.userDetails}
          details={this.state.details}
          leaveBalance={leaveBalance}
          toggleModal={this.toggleModal}
          onApplied={() => this.refreshLeaves()}
        />
      </>
    );
  }
}

const countdown = (date) => {
  const days = moment(date).startOf("day").diff(moment().startOf("day"), "days");
  if (days === 0) return "Today";
  if (days === 1) return "Tomorrow";
  return `In ${days} days`;
};

const StatCard = ({ icon: Icon, tone, label, value, detail }) => (
  <div className="tw-rounded-lg tw-border tw-border-solid tw-border-border/60 tw-bg-card tw-p-5 tw-shadow-soft">
    <div className="tw-flex tw-items-center tw-justify-between">
      <div className="tw-text-sm tw-font-medium tw-text-muted-foreground">
        {label}
      </div>
      <div
        className={`tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-lg ${tone}`}
      >
        <Icon aria-hidden="true" />
      </div>
    </div>
    <div className="tw-mt-2 tw-text-3xl tw-font-semibold tw-leading-9 tw-text-foreground">
      {value}
    </div>
    <div className="tw-mt-1 tw-text-xs tw-text-muted-foreground">{detail}</div>
  </div>
);

const HolidayRow = ({ holiday, today, applied, onApply }) => {
  const date = moment(holiday.date);
  const isOptional = Number(holiday.type) === OPTIONAL_TYPE;
  const isPast = date.isBefore(today, "day");
  const weekend = isWeekend(holiday.date);
  const canApply = isOptional && !weekend && !isPast && !applied;

  return (
    <li
      className={`tw-flex tw-items-center tw-gap-3 tw-px-4 tw-py-3 ${
        isPast ? "tw-opacity-60" : ""
      }`}
    >
      <div
        className={`tw-flex tw-h-12 tw-w-12 tw-shrink-0 tw-flex-col tw-items-center tw-justify-center tw-rounded-lg ${
          isOptional
            ? "tw-bg-amber-50 tw-text-amber-700"
            : "tw-bg-primary/10 tw-text-primary"
        }`}
      >
        <span className="tw-text-lg tw-font-semibold tw-leading-5">
          {date.format("D")}
        </span>
        <span className="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wide">
          {date.format("ddd")}
        </span>
      </div>
      <div className="tw-min-w-0 tw-flex-1">
        <div className="tw-break-words tw-text-sm tw-font-medium tw-leading-5 tw-text-foreground">
          {holiday.holidayName}
        </div>
        <div className="tw-mt-1 tw-flex tw-flex-wrap tw-gap-1">
          <span
            className={`tw-rounded-full tw-px-2 tw-py-px tw-text-[11px] tw-font-medium ${
              isOptional
                ? "tw-bg-amber-50 tw-text-amber-700"
                : "tw-bg-primary/10 tw-text-primary"
            }`}
          >
            {isOptional ? "Optional" : "Public"}
          </span>
          {weekend && (
            <span className="tw-rounded-full tw-bg-secondary tw-px-2 tw-py-px tw-text-[11px] tw-font-medium tw-text-muted-foreground">
              Weekend
            </span>
          )}
        </div>
      </div>
      {applied && (
        <span className="tw-inline-flex tw-shrink-0 tw-items-center tw-gap-1 tw-text-xs tw-font-medium tw-text-success">
          <LuCheckCircle2 aria-hidden="true" />
          Applied
        </span>
      )}
      {canApply && (
        <UiButton variant="outline" size="sm" className="tw-shrink-0" onClick={onApply}>
          Apply
        </UiButton>
      )}
    </li>
  );
};

class ApplyLeaveModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      comment: "",
      btnDisable: false,
    };

    this.handleClose = this.handleClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.showModal && !prevProps.showModal) {
      this.setState({ comment: "", btnDisable: false });
    }
  }

  handleClose() {
    if (typeof this.props.toggleModal !== "undefined") {
      this.props.toggleModal(false);
    }
  }

  isValid() {
    const details = this.props.details || {};
    const balance = this.props.leaveBalance || {};
    return (
      typeof details.date !== "undefined" &&
      typeof balance.chBalance !== "undefined" &&
      Number(balance.chBalance) > 0
    );
  }

  onSubmit() {
    if (!this.isValid()) {
      toast.error("You don't have any optional leave left.");
      return false;
    }

    this.setState({ btnDisable: true }, function () {
      let axiosData = {
        userId: this.props.userDetails.id,
        leaveType: 2, // Optional Leave
        noOfDays: 1,
        transactionType: 1,
        comment: this.state.comment,
        startDate: moment(this.props.details.date).format(config.API_DATE_FORMAT),
        endDate: moment(this.props.details.date).format(config.API_DATE_FORMAT),
      };

      let that = this;
      Axios.post(config.API_BASE + "/leave/insertLeaveDetails?", axiosData)
        .then(function (response) {
          let res = response.data;
          if (res.status) {
            toast.success("Optional leave applied");
            that.handleClose();
            if (that.props.onApplied) that.props.onApplied();
          } else if (typeof res.msg !== "undefined") {
            toast.error(res.msg);
          } else {
            toast.error("Something went wrong. Please try again.");
          }
        })
        .catch(function (error) {
          toast.error("Something went wrong. Please try again.");
          console.log("error", error);
        })
        .finally(function () {
          that.setState({ btnDisable: false });
        });
    });
  }

  handleChange(evt) {
    this.setState({ comment: evt.target.value });
  }

  render() {
    const details = this.props.details || {};
    const balance = Number(this.props.leaveBalance?.chBalance || 0);
    const isValid = this.isValid();

    return (
      <ModalShell
        show={!!this.props.showModal}
        onHide={this.handleClose}
        busy={this.state.btnDisable}
        icon={LuPalmtree}
        title="Apply optional leave"
        subtitle="Uses one day of your optional leave balance."
        footer={
          <>
            <div className="tw-text-xs tw-text-muted-foreground">
              Balance after this:{" "}
              <span className="tw-font-semibold tw-text-foreground">
                {Math.max(balance - 1, 0)}
              </span>
            </div>
            <div className="tw-flex tw-gap-2">
              <UiButton
                variant="outline"
                onClick={this.handleClose}
                disabled={this.state.btnDisable}
              >
                Cancel
              </UiButton>
              <UiButton
                onClick={this.onSubmit}
                disabled={!isValid || this.state.btnDisable}
              >
                {this.state.btnDisable ? (
                  <LuLoader2 className="tw-animate-spin" aria-hidden="true" />
                ) : (
                  <LuCheck aria-hidden="true" />
                )}
                Apply leave
              </UiButton>
            </div>
          </>
        }
      >
        <div className="tw-space-y-5">
          <div className="tw-flex tw-items-center tw-gap-4 tw-rounded-lg tw-border tw-border-solid tw-border-amber-200 tw-bg-amber-50 tw-p-4">
            {details.date && (
              <div className="tw-flex tw-h-14 tw-w-14 tw-shrink-0 tw-flex-col tw-items-center tw-justify-center tw-rounded-lg tw-bg-white tw-text-amber-700 tw-shadow-soft">
                <span className="tw-text-xl tw-font-semibold tw-leading-6">
                  {moment(details.date).format("D")}
                </span>
                <span className="tw-text-[10px] tw-font-semibold tw-uppercase">
                  {moment(details.date).format("MMM")}
                </span>
              </div>
            )}
            <div className="tw-min-w-0">
              <div className="tw-text-base tw-font-semibold tw-text-foreground">
                {details.name || "NA"}
              </div>
              <div className="tw-text-sm tw-text-muted-foreground">
                {details.date
                  ? moment(details.date).format("dddd, DD MMMM YYYY")
                  : "NA"}
              </div>
            </div>
            <div className="tw-ml-auto tw-shrink-0 tw-text-right">
              <div className="tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wide tw-text-muted-foreground">
                Balance
              </div>
              <div
                className={`tw-text-xl tw-font-semibold ${
                  balance > 0 ? "tw-text-foreground" : "tw-text-destructive"
                }`}
              >
                {balance}
              </div>
            </div>
          </div>

          {balance <= 0 && (
            <div className="tw-rounded-md tw-bg-red-50 tw-px-3 tw-py-2 tw-text-sm tw-text-destructive">
              You've used all your optional leave for this year.
            </div>
          )}

          <div>
            <label
              htmlFor="optionalLeaveComment"
              className="tw-m-0 tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-foreground"
            >
              Comment{" "}
              <span className="tw-font-normal tw-text-muted-foreground">
                (optional)
              </span>
            </label>
            <textarea
              id="optionalLeaveComment"
              rows={3}
              className={TEXTAREA}
              placeholder="Add a note for your manager"
              value={this.state.comment}
              onChange={this.handleChange}
            />
          </div>
        </div>
      </ModalShell>
    );
  }
}

export default HolidayList;
